import {Component, ElementRef, inject, output, signal, ViewChild} from '@angular/core';
import {AppBaseComponent} from '../../../shared/components/app-base-component/app-base-component';
import {ChunkUploadService} from '../../../shared/services/chunk-uploader-service';
import {ResizedImage} from '../../../shared/components/resized-image/resized-image';

@Component({
  selector: 'app-upload-images',
  imports: [
    ResizedImage
  ],
  templateUrl: './upload-images.html',
  styleUrl: './upload-images.css',
})
export class UploadImages extends AppBaseComponent {
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  private readonly CHUNK_SIZE = 2 * 1024 * 1024; // 2MB
  uploaderService = inject(ChunkUploadService)
  progress = signal(0);
  uploadedFile = signal(null);
  saved = output();
  onBack = output();

  onFileSelected($event: Event) {
    const input = $event.target as HTMLInputElement;
    if (input.files?.length) {
      this.handleFile(input.files[0]);
    }
  }

  protected select() {
    this.fileInput.nativeElement.click();
  }

  handleFile(file: File) {
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const maxSize = 3 * 1024 * 1024; // 3MB
    this.uploadedFile.set(null);
    if (!allowedTypes.includes(file.type)) {
      alert('Only PNG or JPG images are allowed');
      return;
    }
    this.uploaderService.upload({
        file: file, url: 'upload-user-image',
        onProgress: (progress) => this.progress.set(progress),
        onError: () => {
          this.progress.set(0);
          this.fileInput.nativeElement.value = '';
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to upload image',
          })
        }
      }
    ).then((res: any) => {
      this.uploadedFile.set(res.file)
      this.http.post('user/update-basic-info', {field: 'profile_image', value: res.file}).subscribe(() => {
      })
    },)
  }

}
